import { createAction } from 'redux-actions'

export const getBillingSettingsRequest = createAction('GET_BILLING_SETTINGS_REQUEST')
export const getBillingSettingsSuccess = createAction('GET_BILLING_SETTINGS_SUCCESS')
export const getBillingSettingsFailed = createAction('GET_BILLING_SETTINGS_FAILED')

export const getSessionApprovalSettingsRequest = createAction('GET_SESSION_APPROVAL_SETTINGS_REQUEST')
export const getSessionApprovalSettingsSuccess = createAction('GET_SESSION_APPROVAL_SETTINGS_SUCCESS')
export const getSessionApprovalSettingsFailed = createAction('GET_SESSION_APPROVAL_SETTINGS_FAILED')
